import styled from "styled-components";
import { ImageWrapper } from "@/lib/styles";

export const Container = styled(ImageWrapper)`
  grid-area: icon;
  display: grid;
  place-items: center;
  padding-bottom: 100%;
`;
